import styled from "styled-components";
import colors from "../../constants/colors";
import { Link } from "react-router-dom";

export const HeaderContainer = styled("div")({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  marginBottom: "0.75rem",
});

export const LogoLink = styled(Link)({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  textDecoration: "none",
  color: "inherit",
});

export const Logo = styled("img")({
  height: "100px",
  cursor: "pointer",
});

export const AppName = styled("div")({
  fontFamily: "'Poppins', sans-serif",
  fontSize: "18px",
  color: colors.BLACK,
  marginTop: "0.75rem",
  textDecoration: "none",
});

export const BusinessInfo = styled("div")({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  marginTop: "1rem",
});

export const BusinessName = styled("div")({
  fontSize: "14px",
  fontWeight: 600,
  color: colors.PURPLE,
  textDecoration: "none",
  textAlign: "center",
  letterSpacing: "0.01em",
  opacity: 0.9,
});
